import type { Nurse, SpecificPreference } from "./models";

/**
 * The nurses carrying the time off `timeOffOf` gives (the schedule's, every row touching the weeks a screen reads)
 * instead of their own: what code reading a nurse's `employeeSpecificPreferences` runs on with the schedule cache on.
 */
export const withScheduleTimeOff = (nurses: Nurse[], timeOffOf: (nurseId: number) => SpecificPreference[]): Nurse[] =>
	nurses.map((nurse) => ({ ...nurse, employeeSpecificPreferences: timeOffOf(nurse.id) }));
